import { Language as LanguageIcon } from "@mui/icons-material";
import { FormControl, InputLabel, ListItem, MenuItem, Select, Stack, Typography } from "@mui/material";
import type { LanguageTypes } from "@store/language/types";
import { useAppDispatch } from "index";
import React from "react";
import { setLanguage } from "store/language/actions";
import useLanguageHook from "../hooks/useLanguageHook";
import NavBarButton from "./NavBarButton";

function LanguageSelect({ collapsed, slim }: { collapsed?: boolean; slim?: boolean }) {
  const [open, setOpen] = React.useState(false);
  const dispatch = useAppDispatch();
  const { t, supportedLangs, lang } = useLanguageHook();

  return (
    <Stack direction="row">
      {collapsed && (
        <NavBarButton
          text={t.language}
          icon={<LanguageIcon />}
          collapsed={collapsed}
          onClick={() => setOpen(true)}
          sx={{ maxHeight: 40, maxWidth: 64 }}
        />
      )}
      {slim && !collapsed ? (
        <Select
          sx={{
            height: collapsed ? 0 : 35,
            flexGrow: 1,
            mt: 0.75,
            ml: collapsed ? -2 : "inherit",
            display: collapsed ? "none" : "flex",
          }}
          label="Language"
          labelId="language-label"
          value={lang}
          open={open}
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          onChange={(event) => dispatch(setLanguage(event.target.value as LanguageTypes))}
        >
          {supportedLangs.map((d) => (
            <MenuItem key={d.name} value={d.name}>
              <Stack direction="row" gap={1}>
                <LanguageIcon />
                <Typography variant="h6">{d.text}</Typography>
              </Stack>
            </MenuItem>
          ))}
        </Select>
      ) : (
        <ListItem
          sx={{
            visibility: collapsed ? "hidden" : "visible",
            paddingY: slim ? 0 : null,
          }}
        >
          <FormControl>
            <InputLabel id="language-label">
              <Typography variant="h6">{t.language}</Typography>
            </InputLabel>
            <Select
              sx={{
                height: collapsed ? 0 : 45,
                minWidth: 180,
                flexGrow: 1,
                ml: collapsed ? -2 : "inherit",
              }}
              label="Language"
              labelId="language-label"
              value={lang}
              open={open}
              onClose={() => setOpen(false)}
              onOpen={() => setOpen(true)}
              onChange={(event) => dispatch(setLanguage(event.target.value as LanguageTypes))}
            >
              {supportedLangs.map((d) => (
                <MenuItem key={d.name} value={d.name}>
                  <Stack direction="row" gap={1}>
                    <LanguageIcon />
                    <Typography variant="h6">{d.text}</Typography>
                  </Stack>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </ListItem>
      )}
    </Stack>
  );
}

export default LanguageSelect;
